import { injectIntl } from "react-intl";
import React from "react";

const SearchNotFound = (props) => {

    return (
        <div className={ "flex flex-col w-full min-h-screen justify-center items-center gap-4" }>
            <img alt={ "Logo" } src={ "/media/icons/searchPurple.svg" } className={ "w-14 h-14" }/>
            <div className={ "flex flex-col gap-[6px] justify-center items-center" }>
                <div className={ "EmptyCaseTitle" }>{ props.title }</div>
                <div className={ "EmptyCaseDescription" }>{ props.description }</div>
            </div>
        </div>
    )
}

export default injectIntl(SearchNotFound)